var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobilePage"},[_c('mxMobileVue',{on:{"showWX":_vm.changeWXShow}}),_c('vpnMobileVue',{on:{"showWX":_vm.changeWXShow}}),(_vm.isWXShow)?_c('wxDefaultVue',{on:{"hideWX":_vm.changeWXShow}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }